require('./retailLoanCatalogItem.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const { isEqual } = require('lodash/lang');
const immutable = require('immutable');
const { withRouter } = require("react-router-dom");
//@components
const { RetailLoanCatalogModal } = require('../retailLoanCatalogModal/retailLoanCatalogModal');
const { RetailLoanImageGalleryContainer } = require('../retailLoanImageGalleryContainer/retailLoanImageGalleryContainer');
const { RetailDeliveryInfoBox } = require('../retailDeliveryInfoBox/retailDeliveryInfoBox');
const { RetailLoanOfferType } = require('../retailLoanOfferType/retailLoanOfferType');
const { formatText } = require('core/i18n').i18n;
//@constants
const {
    retailLoanGallery,
    retailLoanDoTaggin: { PRODUCT_NAME_CLICK },
} = require('../../../../loansConstants/index');
const placeHolder = require('../../../../assets/images/placeHolder.png');
//@utilities
const { getFormattedString, decimalsLength } = require('utilities/currencyHelper');
const { recordLinkV2 } = require('utilities/tagging');
const { isRetailAddressDelivery, buildEventClickProductName } = require('../../../../loansUtilities/loansHelper');

class RetailLoanCatalogItemComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            item: this.getItemIterable(props.itemProduct),
            showModal: props.showModal
        }

        this.handleContinueButton = this.handleContinueButton.bind(this);
        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.handleShowInfoProduct = this.handleShowInfoProduct.bind(this);
    }

    getItemIterable(itemProduct) {
        const isIterable = immutable.Iterable.isIterable(itemProduct);
        return isIterable ? itemProduct : immutable.fromJS(itemProduct);
    }

    buildImageGallery() {
        const { item } = this.state;
        const { immRetailLoan, index, disabled } = this.props;
        const zoomSide = index < 2 ? 'right' : 'left';

        return (
            <RetailLoanImageGalleryContainer
                immRetailLoan={immRetailLoan}
                immItem={item}
                listImages={item.get('field_product_images')}
                galleryPosition={retailLoanGallery.POSITION_RIGHT}
                zoomSide={zoomSide}
                zoom={!disabled}
            />
        );
    }

    buildModal() {
        const { setPurpose, setDeliveryDate, labels,
            immRetailLoan, getTermConditionDocuments, setAgree,
            validateAgreeCheckBoxModal, onPrintDocument, onDownloadDocumentTermCondition } = this.props;
        const { item, showModal } = this.state;

        return (
            <RetailLoanCatalogModal
                item={item}
                labels={labels}
                showModal={showModal}
                onHandleToggleModal={this.handleToggleModal}
                setPurpose={setPurpose}
                setDeliveryDate={setDeliveryDate}
                immRetailLoan={immRetailLoan}
                getTermConditionDocuments={getTermConditionDocuments}
                validateAgreeCheckBoxModal={validateAgreeCheckBoxModal}
                setAgree={setAgree}
                onPrintDocument={onPrintDocument}
                onDownloadDocumentTermCondition={onDownloadDocumentTermCondition}
            />
        );
    }

    buildInfoProduct() {
        const { item } = this.state;
        const { labels, currency } = this.props;
        const isAddress = isRetailAddressDelivery(item.get('field_pickup_option'));
        const price = getFormattedString({
            amount: item.get('field_total_product_price'),
            currency: currency,
            decimalsLength: decimalsLength(item.get('field_total_product_price'))
        });
        const modalItem = this.buildModal();
        const installments = formatText('retailLoanCatalogItem-installments');
        const productoCost = `${labels.dateEstimatedDelivery5} ${installments}`

        return (
            <div className="retail-loan-catalog-item__content-info-product">
                {modalItem}
                <React.Fragment>
                    <div className="col-md-12 retail-loan-catalog-item__content-product-cost">
                        <span className="retail-loan-catalog-item__product-cost">{productoCost}</span>
                    </div>
                    <div className="col-md-12 retail-loan-catalog-item__content-product-cost">
                        <span className="retail-loan-catalog-item__content-product-pvp">{labels.dateEstimatedDelivery3} {price}</span>
                    </div>
                </React.Fragment>
                <RetailDeliveryInfoBox isAddress={isAddress} labels={labels} hideDeliveryCondition />
            </div>
        );
    }

    handleContinueButton() {
        const { item } = this.state;
        const { setPurpose, setDeliveryDate, disabled } = this.props;

        if (!disabled) {
            if (setPurpose) {
                setPurpose({ purpose: item.get('nid') });
            }

            if (setDeliveryDate) {
                setDeliveryDate({ deliveryDate: item.get('deliveryDate') });
            }
        }
    }

    handleToggleModal() {
        const { disabled, resetDocumentsAndAgreeCheckBox } = this.props;

        resetDocumentsAndAgreeCheckBox();

        if (!disabled) {
            this.setState({
                showModal: !this.state.showModal
            });
        }
    }

    handleShowInfoProduct() {
        const { item } = this.state;
        const { immRetailLoan, showInfoProduct, setPurpose } = this.props;

        const customDataEvent = buildEventClickProductName(
            immRetailLoan,
            item,
            PRODUCT_NAME_CLICK
        );
        const customData = {
            ...customDataEvent,
            event_name: "event_success",
            action: "success",
            format: "steps",
            component: "funnel",
            element: "list",
        };
        recordLinkV2(customData);
        showInfoProduct();

        if (setPurpose) {
            setPurpose({ purpose: item.get('nid') });
        }

        this.props.history.push(`/myprofile/loans-mortgages/contract-retail-loan/${item.get('nid')}`);
    }

    onLoadErrorImage(e) {
        e.target.src = placeHolder;
    }

    render() {
        const { item } = this.state;
        const { highlightText } = this.props;
        const imageGallery = this.buildImageGallery();
        const infoProduct = this.buildInfoProduct();
        const urlImageProvider = item.get('field_retail_provider') ? item.get('field_retail_provider').get('image') : '';

        return (
            <section className="retail-loan-catalog-item">
                <header className="retail-loan-catalog-item__header">
                    <RetailLoanOfferType item={item} highlightText={highlightText}/>
                    {!isEqual(urlImageProvider, '') &&
                        <img
                            className="retail-loan-catalog-item__logo-catalog-item"
                            src={urlImageProvider}
                            onError={(e) => this.onLoadErrorImage(e)}
                        />
                    }
                </header>
                {imageGallery}
                <div className="col-md-12 retail-loan-catalog-item__container-title">
                    <span
                        className="retail-loan-catalog-item__title"
                        onClick={this.handleShowInfoProduct}
                    >
                        {item.get('title')}
                    </span>
                </div>
                {infoProduct}
            </section>
        );
    }
}

RetailLoanCatalogItemComponent.propTypes = {
    disabled: PropTypes.bool,
    index: PropTypes.number,
    itemProduct: PropTypes.object,
    labels: PropTypes.object.isRequired,
    setPurpose: PropTypes.func,
    showInfoProduct: PropTypes.func,
    setDeliveryDate: PropTypes.func,
    currency: PropTypes.string.isRequired,
    showModal: PropTypes.bool,
    immRetailLoan: PropTypes.object.isRequired,
    getTermConditionDocuments: PropTypes.func.isRequired,
    validateAgreeCheckBoxModal: PropTypes.func.isRequired,
    setAgree: PropTypes.func.isRequired,
    resetDocumentsAndAgreeCheckBox: PropTypes.func.isRequired,
    onPrintDocument: PropTypes.func.isRequired,
    onDownloadDocumentTermCondition: PropTypes.func.isRequired,
    setRetailLoanAccountsInactive: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    highlightText: PropTypes.string,
};

const RetailLoanCatalogItem = withRouter(RetailLoanCatalogItemComponent)

export { RetailLoanCatalogItem };
